export default __webpack_public_path__ + "42ea62f646b76e22a00756f9fe0c7a00.png";